import brandLoader from '../../assets/images/brand-loader.gif'
import './loading-screen.scss'

const LoadingScreen = () => (
  <div className="loading-screen">
    <img src={brandLoader} alt="loading" />
  </div>
)

export default LoadingScreen
